module.exports = __webpack_public_path__ + "static/4-9413febf18d6be46b42c8178b6bd6c36.jpg";